import React from 'react'
import Image from 'next/image'

/* blocks */
import Link from '@/atoms/Link/Link'
import BlogAuthorMeta from '@/atoms/BlogAuthorMeta/BlogAuthorMeta'

interface Props {
  title: string
  categories: WpPostCategory[]
  image?: {
    url: string
    altText: string
    width: number
    height: number
  }
  author: Author
  meta: BlogMeta
}

function IndividualBlogHero({ image, categories, title, author, meta }: Props) {
  const primaryCategory =
    categories.find(category => category.isPrimary) ?? categories[0]

  return (
    <header className="max-w-[986px] mx-auto mb-10">
      <div className="text-center  |  max-w-3xl  |  mx-auto mb-8 px-5">
        <Link
          href={`/blog/category/${primaryCategory.node.slug}/`}
          className="text-small font-medium text-purple-50  |  inline-block  |  mb-4"
        >
          {primaryCategory.node.name}
        </Link>
        <h1 className="h3 font-bold  | mb-4">{title}</h1>

        <BlogAuthorMeta
          className="flex justify-center"
          author={author}
          meta={meta}
        />
      </div>

      {image && (
        <div className="flex justify-center">
          <Image
            src={image.url}
            alt={image.altText || title}
            width={image.width}
            height={image.height}
            priority={true}
          />
        </div>
      )}
    </header>
  )
}

export default IndividualBlogHero
